import { render } from "./yuklamaJadval.vue?vue&type=template&id=b8dc819e&scoped=true"
import script from "./yuklamaJadval.vue?vue&type=script&lang=js"
export * from "./yuklamaJadval.vue?vue&type=script&lang=js"

import "./yuklamaJadval.vue?vue&type=style&index=0&id=b8dc819e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8dc819e"]])

export default __exports__